import React, { useEffect } from 'react';
import { Modal, Form, Input, Select } from 'antd';
import { useCity } from '../city.hook';
import { CityRequest } from '../../../request/city.request';
import { validateLevel, validateLevelName } from '../../../validator/level.validator';
import { CityRes } from '../../../response/city.response';
import { handleFilter } from '../../../view/input.helper';
import { ItemProp } from '../../../model/item-prop.model';
import { CountryRes } from '../../../response/country.response';
import { Media } from '../../../model/media.model';
import FileUploadView from '../../../view/file-upload.view';
import LocationPickerView from '../../../view/location-picker.view';
import { Location } from '../../../model/location.model';

export const UpdateCityComponent: React.FC<{ city: CityRes, open: boolean, onCancel: () => void }> = ({ city, open, onCancel }) => {
    const [form] = Form.useForm();
    const { loading, countryList, updateLoading, updateCity, fetchCountryList } = useCity()

    const handleOk = () => {
        form.validateFields().then(values => {
            updateLoading(true);
            const cityRequest = {
                name: values["name"],
                location: values["location"],
                thumbnail: values["thumbnail"],
                countryId: values["countryId"],
                tint: values["tint"],
                order: Number(values["order"])
            } as CityRequest
            updateCity(city.id, cityRequest, onSuccess, onFailure)
        });
    };

    const onSuccess = () => {
        updateLoading(false);
        form.resetFields()
        onCancel();
    }

    const onFailure = () => {
        updateLoading(false);
    }

    useEffect(() => {
        fetchCountryList()
    }, [])

    return (
        <Modal
            open={open}
            title="Add New City"
            onCancel={onCancel}
            confirmLoading={loading}
            onOk={handleOk}
            okText={"Submit"}
            cancelText={"Cancel"}
            style={{ top: 8, maxWidth: 768 }}
            width={'90vw'}
        >
            <Form form={form} layout="vertical">
                <Form.Item
                    name="name"
                    label="Name"
                    rules={[{ required: true, validator: validateLevelName }]}
                    initialValue={city.name}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    name="tint"
                    label="Tint Color"
                    rules={[{ required: true }]}
                    initialValue={city.tint}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    name="countryId"
                    label="Country"
                    rules={[{ required: true, message: 'Country Id' }]}
                    initialValue={city.country?.id}
                >
                    <Select
                        showSearch={true}
                        value='countryId'
                        options={countryList.map((countryRes: CountryRes) => {
                            return {
                                label: `${countryRes.name}`,
                                value: countryRes.id
                            } as ItemProp
                        })}
                        filterOption={handleFilter} />
                </Form.Item>

                <Form.Item
                    name="order"
                    label="Order"
                    rules={[{ required: true, validator: validateLevel }]}
                    initialValue={city.order}
                >
                    <Input placeholder="Enter level" />
                </Form.Item>

                <Form.Item
                    name="thumbnail"
                    label="Thumbnail"
                    initialValue={city.thumbnail}
                >
                    <FileUploadView onChange={(media: Media) => { }} />
                </Form.Item>

                <Form.Item
                    name="location"
                    label="Location"
                >
                    <LocationPickerView onChange={(location: Location) => { }} />
                </Form.Item>


            </Form>
        </Modal>
    );
}